module.exports = __webpack_public_path__ + "static/img/news-20220805.dc70fe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20220805.png
// module id = jsw+
// module chunks = 0